var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDraft)?_c('div',[_c('message-preview-draft',{attrs:{"index":_vm.index,"action":_vm.action}})],1):_c('div',[_c('message-preview',{attrs:{"index":_vm.index,"action":_vm.action}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }